<script setup lang="ts">
const props = defineProps<{
  attributes: {
    [x: string]: string
  }
}>()

const { loadLayout, tooltips } = useLayout()
await loadLayout()

const isCustomMade = computed<boolean>(() => {
  return props.attributes?.poo_is_custom_made === 'Ja'
})

const tooltip = computed(() => {
  return tooltips.value.get('maatwerk')
})
</script>

<template>
  <div
    v-if="isCustomMade && tooltip"
    class="pdp__customisation-container"
  >
    <div class="pdp__customisation-title">
      {{ tooltip.Title }}
    </div>
    <div class="pdp__customisation-text">
      <StrapiBlocksText
        :nodes="tooltip.Richtext"
      />
    </div>
  </div>
</template>

<style>

</style>
